<template>
  <v-app class="user_content" v-if="!isAdmin">
    <v-main class="">
      <Component :is="currentNavComponent"/>
      <div class="">
        <router-view v-slot="{ Component }">
          <Component :is="Component" />
        </router-view>
        <Modals ref="modals" />
      </div>
      <MainFooter v-if="!isInvitation"/>
    </v-main>
  </v-app>
  <v-app id="wrap" v-else>
    <Component :is="currentNavComponent"/>
    <v-main>
      <router-view v-slot="{ Component }">
        <Component :is="Component" />
      </router-view>
      </v-main>
  </v-app>
</template>

<script>
import NavigationMenu from "./views/layout/navigation/NavigationMenu.vue";
import AdminSideBar from "./views/layout/navigation/AdminSideBar.vue"
import MainFooter from "./views/layout/footer/MainFooter.vue";
import Modals from '@/components/common/Modals.vue';
import emitter from './utility/eventBus';
import { mapActions } from "vuex";

const adminAccountModule = 'adminAccountModule'

export default {
  components: {
    MainFooter,
    Modals
  },
  data () {
    return {
      currentNavComponent: null,
      isAdmin: null,
      isInvitation: false,
    }
  },

  watch: {
     async $route(to) {
      if (to.path.startsWith('/admin')) {
        this.isAdmin = true
        if (await this.requestCheckAdmin()) {
          this.currentNavComponent = AdminSideBar;
          if (to.path === '/admin') {
            this.$router.push({ name: 'AdminAccountManageListPage' })
          }
        } else {
          this.currentNavComponent = null
          if (to.path !== '/admin/login') {
            alert('로그인 후 이용 할 수 있습니다')
            this.$router.push({ name: 'AdminLoginPage' })
          }
        }
      } else if (to.path.startsWith('/invitation')){
        this.currentNavComponent = null
        this.isInvitation = true
      } else {
        this.currentNavComponent = NavigationMenu;
        this.isAdmin = false
        this.isInvitation = false
      }
    },
  },

  methods: {
    ...mapActions(adminAccountModule, ['requestCheckAdmin']),

    openModal(type, options = {}) {
      this.$refs.modals.showModal(type, options);
    },
  },

  mounted() {
    emitter.on('openModal', ({ type, options }) => {
      if (this.$refs.modals) {
        this.$refs.modals.showModal(type, options);
      } else {
        console.warn('Modals 컴포넌트가 아직 준비되지 않았습니다.');
      }
    });
  },
}
</script>

<style>
nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

/* .user_content {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */

@font-face {
	font-family: 'Noto Sans KR';
	font-style: normal;
	font-weight: 100;
	src: local(''),
		url('assets/font/NotoSansKR/NotoSansKR-100.eot?#iefix') format('embedded-opentype'),
		url('assets/font/NotoSansKR/NotoSansKR-100.woff2') format('woff2'),
		url('assets/font/NotoSansKR/NotoSansKR-100.woff') format('woff'),
		url('assets/font/NotoSansKR/NotoSansKR-100.svg#NotoSansKR') format('svg');
}

@font-face {
	font-family: 'Noto Sans KR';
	font-style: normal;
	font-weight: 300;
	src: local(''),
		url('assets/font/NotoSansKR/NotoSansKR-300.eot?#iefix') format('embedded-opentype'),
		url('assets/font/NotoSansKR/NotoSansKR-300.woff2') format('woff2'),
		url('assets/font/NotoSansKR/NotoSansKR-300.woff') format('woff'),
		url('assets/font/NotoSansKR/NotoSansKR-300.svg#NotoSansKR') format('svg');
}

@font-face {
	font-family: 'Noto Sans KR';
	font-style: normal;
	font-weight: 400;
	src: local(''),
		url('assets/font/NotoSansKR/NotoSansKR-Regular.eot?#iefix') format('embedded-opentype'),
		url('assets/font/NotoSansKR/NotoSansKR-Regular.woff2') format('woff2'),
		url('assets/font/NotoSansKR/NotoSansKR-Regular.woff') format('woff'),
		url('assets/font/NotoSansKR/NotoSansKR-Regular.svg#NotoSansKR') format('svg');
}

@font-face {
	font-family: 'Noto Sans KR';
	font-style: normal;
	font-weight: 500;
	src: local(''),
		url('assets/font/NotoSansKR/NotoSansKR-500.eot?#iefix') format('embedded-opentype'),
		url('assets/font/NotoSansKR/NotoSansKR-500.woff2') format('woff2'),
		url('assets/font/NotoSansKR/NotoSansKR-500.woff') format('woff'),
		url('assets/font/NotoSansKR/NotoSansKR-500.svg#NotoSansKR') format('svg');
}

@font-face {
	font-family: 'Noto Sans KR';
	font-style: normal;
	font-weight: 700;
	src: local(''),
		url('assets/font/NotoSansKR/NotoSansKR-700.eot?#iefix') format('embedded-opentype'),
		url('assets/font/NotoSansKR/NotoSansKR-700.woff2') format('woff2'),
		url('assets/font/NotoSansKR/NotoSansKR-700.woff') format('woff'),
		url('assets/font/NotoSansKR/NotoSansKR-700.svg#NotoSansKR') format('svg');
}

@font-face {
	font-family: 'Noto Sans KR';
	font-style: normal;
	font-weight: 900;
	src: local(''),
		url('assets/font/NotoSansKR/NotoSansKR-900.eot?#iefix') format('embedded-opentype'),
		url('assets/font/NotoSansKR/NotoSansKR-900.woff2') format('woff2'),
		url('assets/font/NotoSansKR/NotoSansKR-900.woff') format('woff'),
		url('assets/font/NotoSansKR/NotoSansKR-900.svg#NotoSansKR') format('svg');
}

/* Pretendard */
@font-face {
	font-family: 'Pretendard';
	src: url(assets/font/PretendardVariable.ttf) format(truetype);
  }

  /* NEXEN TIRE */
  @font-face {
	font-family: 'NEXEN_B';
	src: url(assets/font/NEXEN_Bold.ttf) format(truetype);
  }

  @font-face {
	font-family: 'NEXEN_R';
	src: url(assets/font/NEXEN_Regular.ttf) format(truetype);
  }

  /* Gmarket Sans */
  @font-face {
	font-family: 'GmarketSans';
	font-weight: 300;
	src: url(assets/font/GmarketSansTTFLight.ttf) format(truetype);
  }
  @font-face {
	font-family: 'GmarketSans';
	font-weight: 500;
	src: url(assets/font/GmarketSansTTFMedium.ttf) format(truetype);
  }
  @font-face {
	font-family: 'GmarketSans';
	font-weight: 700;
	src: url(assets/font/GmarketSansTTFBold.ttf) format(truetype);
  }

  /* Dancing Script */
  @font-face {
	font-family: 'DancingScript';
	src: url(assets/font/DancingScript.ttf) format(truetype);
  }

    /* Cormorant */
@font-face {
	font-family: 'Cormorant';
	src: url(assets/font/Cormorant-VariableFont_wght.ttf) format(truetype);
  }

  /* GangwonEdu */
  @font-face {
	font-family: 'GangwonEdu_OTFBoldA';
	src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_2201-2@1.0/GangwonEdu_OTFBoldA.woff') format('woff');
	font-weight: normal;
	font-style: normal;
  }

  /* BookkMyungjo */
  @font-face {
	font-family: 'BookkMyungjoBold';
	src: url(assets/font/BookkMyungjo_Bold.ttf) format(truetype);
  }
  @font-face {
	font-family: 'BookkMyungjoLight';
	src: url(assets/font/BookkMyungjo_Light.ttf) format(truetype);
  }

  /* Noto Serif KR */
  @font-face {
	font-family: 'NotoSerifKR_bold';
	src: url(assets/font/NotoSerifKR-Bold.ttf) format(truetype);
  }
  @font-face {
	font-family: 'NotoSerifKR_normal';
	src: url(assets/font/NotoSerifKR-Regular.ttf) format(truetype);
  }

    /* cafe24 */
  @font-face {
    font-family: 'Cafe24Ssurround';
    src: url(assets/font/Cafe24Ssurround.ttf) format(truetype);
  }
  @font-face {
    font-family: 'Cafe24SsurroundAir';
    src: url(assets/font/Cafe24SsurroundAir.ttf) format(truetype);
  }
  @font-face {
    font-family: 'Cafe24Simplehae';
    src: url(assets/font/Cafe24Simplehae.ttf) format(truetype);
  }
</style>

